import { instance } from './instance';

/**
 * Service für Produkt-API-Anfragen
 */
export const productsService = {
  /**
   * Holt alle Produkte
   * @returns {Promise} Antwort mit Produkten
   */
  getProducts() {
    return instance.get('/products')
  },

  /**
   * Holt ein Produkt nach ID
   * @param {string} productId - Produkt-ID
   * @returns {Promise} Antwort mit Produktdaten
   */
  getProduct(productId) {
    return instance.get(`/products/${productId}`)
  },

  /**
   * Holt alle Kategorien
   * @returns {Promise} Antwort mit Kategorien
   */
  getCategories() {
    return instance.get('/categories')
  },

  /**
   * Holt alle Produkte einer Kategorie
   * @param {string} categoryId - Kategorie-ID
   * @returns {Promise} Antwort mit Produkten
   */
  getProductsByCategory(categoryId) {
    return instance.get(`/categories/${categoryId}/products`)
  },

  /**
   * Holt alle Extras
   * @returns {Promise} Antwort mit Extras
   */
  getExtras() {
    return instance.get('/extras')
  },

  /**
   * Erstellt ein neues Produkt
   * @param {Object} productData - Produktdaten
   * @returns {Promise} Antwort mit erstelltem Produkt
   */
  createProduct(productData) {
    return instance.post('/products', productData)
  },

  /**
   * Aktualisiert ein Produkt
   * @param {string} productId - Produkt-ID
   * @param {Object} productData - Aktualisierte Produktdaten
   * @returns {Promise} Antwort mit aktualisiertem Produkt
   */
  updateProduct(productId, productData) {
    return instance.put(`/products/${productId}`, productData)
  },

  /**
   * Löscht ein Produkt
   * @param {string} productId - Produkt-ID
   * @returns {Promise} Antwort mit Status
   */
  deleteProduct(productId) {
    return instance.delete(`/products/${productId}`)
  },

  /**
   * Lädt ein Produktbild hoch
   * @param {string} productId - Produkt-ID
   * @param {File} file - Bilddatei
   * @returns {Promise} Antwort mit Bild-URL
   */
  uploadProductImage(productId, file) {
    const formData = new FormData()
    formData.append('file', file)
    
    return instance.post(`/products/${productId}/image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
} 